import { apiClient, ensureCsrfCookie } from '@/api/client'
import type { ApiSuccessResponse } from '@/types/api'

export interface NotificationItem {
  id: string
  title: string | null
  body: string | null
  link: string | null
  readAt: string | null
  createdAt: string
}

interface NotificationListMeta {
  currentPage: number
  perPage: number
  total: number
  lastPage: number
  unreadCount: number
}

async function withCsrf<T>(fn: () => Promise<T>): Promise<T> {
  await ensureCsrfCookie()
  return fn()
}

export const notificationsApi = {
  list: async (perPage = 20) => {
    const { data } = await apiClient.get<
      ApiSuccessResponse<NotificationItem[]> & { meta: NotificationListMeta }
    >('/notifications', { params: { per_page: perPage } })
    return { notifications: data.data, meta: data.meta }
  },

  unreadCount: async () => {
    const { data } = await apiClient.get<ApiSuccessResponse<{ unreadCount: number }>>(
      '/notifications/unread-count',
    )
    return data.data.unreadCount
  },

  markRead: (id: string) =>
    withCsrf(async () => {
      const { data } = await apiClient.patch<ApiSuccessResponse<NotificationItem>>(
        `/notifications/${id}/read`,
      )
      return data.data
    }),

  markAllRead: () => withCsrf(() => apiClient.post('/notifications/read-all')),
}
